/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from "react";
import "./header.scss";
import HeaderLogo from "../../assets/images/logo.png";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { appRoutesConst } from "app/navigation";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useState } from "react";
import { LinkContainer } from "react-router-bootstrap";
import NavbarComponent from "./NavBar";
import Swing from "react-reveal/Swing";
import Tada from "react-reveal/Tada";
import Zoom from "react-reveal/Zoom";
import { Dropdown } from "rsuite";
import { Button, Divider, Popover, Segmented } from "antd";
import { getPackages } from "services/packages";
import BadgeHeaderImage from "../../assets/images/badge-2.webp";
import DiscountVoucherImage from "../../assets/images/discount-offer.jpeg";

const Header = () => {
  const [show, setShow] = useState(false);
  const [packages, setPackages] = useState({
    Other: [],
    Hajj: [],
    Umrah: [],
  });
  const [hajjPackages, setHajjPackages] = useState([]);
  const [umrahPackages, setUmrahPackages] = useState([]);
  const [otherPackages, setOtherPackages] = useState([]);
  const [isLoading, setLoading] = useState([]);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const handleShow = () => {
    setShow(true);
  };
  const toggleOffCanvas = () => {
    setShow((show) => !show);
  };

  useEffect(() => {
    setTimeout(() => {
      // _getUmrahPackages();
      // _getHajjPackages();
      // _getOtherPackages();
    }, 2000);
  }, []);

  // const _getUmrahPackages = async (forType) => {
  //   setLoading(true);
  //   try {
  //     const response = await getPackages({ forType: "Umrah" });
  //     let dd = response?.data?.data.docs;
  //     setUmrahPackages(dd);
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //   }
  //   // }
  // };

  // const _getHajjPackages = async (forType) => {
  //   setLoading(true);
  //   try {
  //     const response = await getPackages({ forType: "Hajj" });
  //     let dd = response?.data?.data.docs;
  //     setHajjPackages(dd);
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //   }
  //   // }
  // };

  // const _getOtherPackages = async (forType) => {
  //   setLoading(true);
  //   try {
  //     const response = await getPackages({ forType: "Other" });
  //     let dd = response?.data?.data.docs;
  //     setOtherPackages(dd);
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //   }
  // };

  console.log("packages ", packages);
  return (
    <>
      <header id="header-main" className="header-section">




        {/* <div className="top-header">
          <div className="top-header-right text-right d-flex justify-content-end">
            <div className="text-white font-size-14">
            <a href="tel:1-773-4658-500" className="header-icon text-white">
              <img src={CallIcon} alt="" className="img-fluid" />                
              </a>
              <a href="tel:1-773-4658-500" className="mobile-d-none text-white">
                {" "}
                (773) 465-8500{" "}
              </a>
              
              <span className="px-3 mobile-d-none">|</span>
            </div>
            <div className="text-white font-size-14">
            <a
                href="mailto:info@chicagohajj.com"
                className="header-icon text-white"
              >
                <img src={IconEmail} alt="" className="img-fluid" />
              </a>
              <a
                href="mailto:info@chicagohajj.com"
                className="mobile-d-none text-white"
              >
                info@chicagohajj.com
              </a>
             
              <span className="px-3  mobile-d-none">|</span>
            </div>
            <div className="text-white font-size-12">
              <a
                href="https://api.whatsapp.com/send?phone=7734658500"
                target="_blank"
                className="mobile-d-none text-white"
              >
                Whats App: (773) 465-8500
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=7734658500"
                className="header-icon text-white"
              >
                <i class="fa-brands fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div> */}

        <div className="bottom-header d-block">
          {["lg"].map((expand) => (
            <Navbar key={expand} expand={expand} className="mb-0">
              <Container fluid>
                <Navbar.Brand>
                  <div className="header-logo">
                    <Link to={"/"} className="cursor-pointer">
                      <img
                        src={HeaderLogo}
                        alt="Website Logo"
                        className="img-fluid"
                      />{" "}
                    </Link>
                  </div>
                </Navbar.Brand>
                <div className="mobile-contact">
                  <div className="bottom-header-right">
                    <div className="header-contact">
                      <div className="d-flex align-items-center">
                        <Swing delay={20}>
                          <div className="contact-icon">
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M28.4252 22.3007C27.6882 21.5333 26.7992 21.123 25.857 21.123C24.9225 21.123 24.0259 21.5257 23.2585 22.2931L20.8575 24.6865C20.66 24.5801 20.4624 24.4813 20.2725 24.3825C19.9989 24.2458 19.7406 24.1166 19.5203 23.9798C17.2712 22.5514 15.2274 20.6899 13.2671 18.2813C12.3173 17.0808 11.6791 16.0703 11.2156 15.0445C11.8386 14.4747 12.4161 13.882 12.9783 13.3122C13.1911 13.0994 13.4038 12.8791 13.6166 12.6664C15.2122 11.0708 15.2122 9.0041 13.6166 7.40851L11.5423 5.33424C11.3068 5.0987 11.0636 4.85556 10.8357 4.61243C10.3798 4.14135 9.90113 3.65507 9.40725 3.19919C8.67024 2.46978 7.78887 2.08228 6.86191 2.08228C5.93495 2.08228 5.03838 2.46978 4.27857 3.19919C4.27097 3.20679 4.27097 3.20679 4.26338 3.21438L1.68004 5.82051C0.707491 6.79306 0.152834 7.97836 0.0312648 9.35361C-0.151088 11.5722 0.502344 13.6389 1.00381 14.9914C2.2347 18.3117 4.07343 21.3889 6.81632 24.6865C10.1443 28.6602 14.1484 31.7982 18.7225 34.0093C20.47 34.8375 22.8026 35.8176 25.4087 35.9848C25.5683 35.9924 25.7355 36 25.8874 36C27.6426 36 29.1166 35.3693 30.2715 34.1156C30.2791 34.1004 30.2943 34.0928 30.3019 34.0776C30.697 33.599 31.1529 33.1659 31.6315 32.7024C31.9583 32.3909 32.2926 32.0642 32.6193 31.7223C33.3715 30.9397 33.7666 30.0279 33.7666 29.0933C33.7666 28.1512 33.3639 27.247 32.5965 26.4872L28.4252 22.3007ZM31.1453 30.3014C31.1377 30.3014 31.1377 30.309 31.1453 30.3014C30.8489 30.6205 30.545 30.9093 30.2183 31.2284C29.7244 31.6995 29.223 32.1933 28.7519 32.748C27.9845 33.5686 27.0803 33.9561 25.895 33.9561C25.781 33.9561 25.6595 33.9561 25.5455 33.9485C23.2889 33.8041 21.1918 32.9227 19.619 32.1705C15.3185 30.0887 11.5423 27.133 8.40431 23.3872C5.81338 20.2644 4.08102 17.3771 2.93372 14.2771C2.2271 12.3852 1.96877 10.9112 2.08274 9.52076C2.15872 8.63179 2.50063 7.89478 3.13127 7.26414L5.7222 4.67321C6.09451 4.3237 6.4896 4.13375 6.8771 4.13375C7.35578 4.13375 7.74328 4.42247 7.98642 4.66561C7.99402 4.67321 8.00162 4.68081 8.00921 4.68841C8.47269 5.12149 8.91338 5.56978 9.37686 6.04846C9.6124 6.29159 9.85554 6.53473 10.0987 6.78547L12.1729 8.85973C12.9783 9.66513 12.9783 10.4097 12.1729 11.2151C11.9526 11.4355 11.7399 11.6558 11.5195 11.8686C10.8813 12.522 10.2734 13.1298 9.6124 13.7225C9.59721 13.7377 9.58201 13.7453 9.57441 13.7605C8.92098 14.4139 9.04255 15.0521 9.17931 15.4852C9.18691 15.508 9.19451 15.5308 9.20211 15.5536C9.74157 16.8605 10.5014 18.0914 11.6563 19.5578L11.6639 19.5654C13.7609 22.1487 15.972 24.1622 18.4109 25.7046C18.7225 25.9021 19.0416 26.0617 19.3455 26.2137C19.619 26.3504 19.8774 26.4796 20.0977 26.6164C20.1281 26.6316 20.1585 26.6544 20.1889 26.6696C20.4472 26.7987 20.6904 26.8595 20.9411 26.8595C21.5717 26.8595 21.9668 26.4644 22.096 26.3352L24.6945 23.7367C24.9529 23.4784 25.3631 23.1669 25.8418 23.1669C26.3129 23.1669 26.7004 23.4632 26.9359 23.7215C26.9435 23.7291 26.9435 23.7291 26.9511 23.7367L31.1377 27.9232C31.9203 28.6982 31.9203 29.496 31.1453 30.3014Z"
                                fill="#118DFF"
                              />
                              <path
                                d="M19.4283 8.56338C21.419 8.89769 23.2273 9.83985 24.6709 11.2835C26.1146 12.7271 27.0491 14.5354 27.391 16.5261C27.4746 17.0276 27.9077 17.3771 28.4016 17.3771C28.4624 17.3771 28.5156 17.3695 28.5763 17.3619C29.1386 17.2707 29.5109 16.7389 29.4197 16.1766C29.0094 13.768 27.8697 11.5722 26.1298 9.83225C24.3898 8.0923 22.194 6.95259 19.7854 6.5423C19.2231 6.45112 18.6989 6.82342 18.6001 7.37808C18.5013 7.93274 18.866 8.4722 19.4283 8.56338Z"
                                fill="#118DFF"
                              />
                              <path
                                d="M35.9311 15.8804C35.2549 11.9142 33.3858 8.30511 30.5137 5.43304C27.6417 2.56098 24.0326 0.691864 20.0664 0.0156379C19.5118 -0.0831367 18.9875 0.296766 18.8887 0.851423C18.7975 1.41368 19.1699 1.93794 19.7321 2.03672C23.2728 2.63696 26.502 4.31613 29.0701 6.87667C31.6382 9.44481 33.3098 12.674 33.9101 16.2147C33.9936 16.7161 34.4267 17.0657 34.9206 17.0657C34.9814 17.0657 35.0346 17.0581 35.0954 17.0505C35.65 16.9669 36.0299 16.435 35.9311 15.8804Z"
                                fill="#118DFF"
                              />
                            </svg>
                          </div>
                        </Swing>
                        <Tada delay={20} cascade>
                          <div className="contact-right position-relative">
                            <Zoom delay={50} right cascade>
                              <p className="mb-0 font-size-10">
                                Call Us for Phone-Exclusive Deal
                              </p>
                            </Zoom>
                            <Zoom duration={2500} right cascade>
                              <a
                                href="tel:1-773-4658-500"
                                className="font-weight-bold mb-0 cursor-pointer"
                              >
                                773-465-8500
                              </a>
                            </Zoom>
                          </div>
                        </Tada>
                      </div>
                    </div>
                  </div>
                  <div className="header-badge">
                    <img
                      src={BadgeHeaderImage}
                      alt="icon media"
                      className="img-fluid"
                    />
                  </div>
                </div>
                <Navbar.Toggle
                  onClick={handleShow}
                  aria-controls={`offcanvasNavbar-expand-${expand}`}
                />
                {
                  <NavbarComponent
                    toggleOffCanvas={toggleOffCanvas}
                    show={show}
                    umrahPackages={umrahPackages}
                    hajjPackages={hajjPackages}
                    otherPackages={otherPackages}
                    isLoading={isLoading}
                  />
                }
                <Navbar.Offcanvas
                  id={`offcanvasNavbar-expand-${expand}`}
                  aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                  placement="end"
                  show={false}
                  restoreFocus={false}
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title
                      id={`offcanvasNavbarLabel-expand-${expand}`}
                    ></Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Nav className="me-auto custom-nav flex-grow-1 mb-0">
                      <LinkContainer to="/">
                        <Nav.Link
                          className={`font-weight-semibold nav-link ${
                            pathname === appRoutesConst.index && "active"
                          }`}
                        >
                          Home
                        </Nav.Link>
                      </LinkContainer>
                      <LinkContainer to="/packages/Umrah">
                        <Nav.Link
                          className={`font-weight-semibold nav-link ${
                            pathname === `/packages/Umrah` && "active"
                          }`}
                        >
                          Umrah Packages
                        </Nav.Link>
                      </LinkContainer>
                      <LinkContainer to="/packages/Hajj">
                        <Nav.Link
                          className={`font-weight-semibold nav-link ${
                            pathname === `/packages/Hajj` && "active"
                          }`}
                        >
                          Hajj Packages
                        </Nav.Link>
                      </LinkContainer>
                      {/* <LinkContainer to="/packages/ramadan-umrah">
                        <Nav.Link
                          className={`font-weight-semibold nav-link ${
                            pathname === `/packages/ramadan-umrah` && "active"
                          }`}
                        >
                         Ramadan Umrah
                        </Nav.Link>
                      </LinkContainer> */}
                      <LinkContainer to="/packages/Other">
                        <Nav.Link
                          className={`font-weight-semibold nav-link ${
                            pathname === `/packages/Other` && "active"
                          }`}
                        >
                          Tour Packages
                        </Nav.Link>
                      </LinkContainer>
                      <LinkContainer to="/blogs">
                        <Nav.Link
                          className={`font-weight-semibold nav-link ${
                            pathname === `/blogs` && "active"
                          }`}
                        >
                         Blogs
                        </Nav.Link>
                      </LinkContainer>
                      {/* <Popover
                        title={"Umrah Packages"}
                        placement="bottom"
                        // trigger="click"
                        arrow={true}
                        // onMouseEnter={() => {
                        //   if (umrahPackages.length === 0) {
                        //     // _getUmrahPackages();
                        //   }
                        // }}
                        content={
                          <div>
                            {isLoading && (
                              <span className="text-center">Loading ...</span>
                            )}
                            {!isLoading && umrahPackages.length === 0 && (
                              <span className="text-center">
                                {" "}
                                No Packages Found
                              </span>
                            )}
                            {!isLoading &&
                              umrahPackages.length > 0 &&
                              umrahPackages?.slice(0, 5).map((_p) => {
                                return (
                                  <LinkContainer
                                    to={`/packages/Umrah/${_p?._id}`}
                                    target="__blank"
                                  >
                                    <Nav.Link
                                      className={`dropdown-custom-menu font-weight-semibold nav-link ${
                                        pathname ===
                                          `/packages/Umrah/${_p?._id}` &&
                                        "active"
                                      }`}
                                    >
                                      {_p?.title}
                                    </Nav.Link>
                                  </LinkContainer>
                                );
                              })}
                          </div>
                        }
                      >
                        <LinkContainer to="/packages/Umrah">
                          <Nav.Link
                            className={`font-weight-semibold nav-link ${
                              pathname === `/packages/Umrah` && "active"
                            }`}
                          >
                            Umrah Packages
                          </Nav.Link>
                        </LinkContainer>
                      </Popover> */}
                      {/* <Popover
                        title={"Hajj Packages"}
                        placement="bottom"
                        arrow={true}
                        content={
                          <div>
                            {isLoading && (
                              <span className="text-center">Loading ...</span>
                            )}
                            {!isLoading && hajjPackages.length === 0 && (
                              <span className="text-center">
                                {" "}
                                No Packages Found
                              </span>
                            )}
                            {!isLoading &&
                              hajjPackages.length > 0 &&
                              hajjPackages?.slice(0, 5)?.map((_p) => {
                                return (
                                  <LinkContainer
                                    to={`/packages/Hajj/${_p?._id}`}
                                    target="__blank"
                                  >
                                    <Nav.Link
                                      className={`dropdown-custom-menu font-weight-semibold nav-link ${
                                        pathname ===
                                          `/packages/Hajj/${_p?._id}` &&
                                        "active"
                                      }`}
                                    >
                                      {_p?.title}
                                    </Nav.Link>
                                  </LinkContainer>
                                );
                              })}
                          </div>
                        }
                      >
                        <LinkContainer to="/packages/Hajj">
                          <Nav.Link
                            className={`font-weight-semibold nav-link ${
                              pathname === `/packages/Hajj` && "active"
                            }`}
                          >
                            Hajj Packages
                          </Nav.Link>
                        </LinkContainer>
                      </Popover> */}
                      {/* <Popover
                        title={"Other Packages"}
                        placement="bottom"
                        arrow={true}
                        // onMouseEnter={() => {
                        //   if (otherPackages.length === 0) {
                        //     _getOtherPackages();
                        //   }
                        // }}
                        content={
                          <div>
                            {isLoading && (
                              <span className="text-center">Loading ...</span>
                            )}
                            {!isLoading && otherPackages.length === 0 && (
                              <span className="text-center">
                                {" "}
                                No Packages Found
                              </span>
                            )}
                            {!isLoading &&
                              otherPackages.length > 0 &&
                              otherPackages?.slice(0.5)?.map((_p) => {
                                return (
                                  <LinkContainer
                                    to={`/packages/Other/${_p?._id}`}
                                    target="__blank"
                                  >
                                    <Nav.Link
                                      className={`dropdown-custom-menu font-weight-semibold nav-link ${
                                        pathname ===
                                          `/packages/Other/${_p?._id}` &&
                                        "active"
                                      }`}
                                    >
                                      {_p?.title}
                                    </Nav.Link>
                                  </LinkContainer>
                                );
                              })}
                          </div>
                        }
                      >
                        <LinkContainer to="/packages/Other">
                          <Nav.Link
                            className={`font-weight-semibold nav-link ${
                              pathname === `/packages/Other` && "active"
                            }`}
                          >
                            Other Packages
                          </Nav.Link>
                        </LinkContainer>
                      </Popover> */}
                    </Nav>
                    {/* <div className="discount-offer">
                      <img
                        src={DiscountVoucherImage}
                        alt="icon media"
                        className="img-fluid"
                      />
                    </div> */}
                    <div className="bottom-header-right">
                      <div className="header-contact">
                        <div className="d-flex align-items-center">
                          <Swing delay={20}>
                            <div className="contact-icon trin">
                              <svg
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M28.4252 22.3007C27.6882 21.5333 26.7992 21.123 25.857 21.123C24.9225 21.123 24.0259 21.5257 23.2585 22.2931L20.8575 24.6865C20.66 24.5801 20.4624 24.4813 20.2725 24.3825C19.9989 24.2458 19.7406 24.1166 19.5203 23.9798C17.2712 22.5514 15.2274 20.6899 13.2671 18.2813C12.3173 17.0808 11.6791 16.0703 11.2156 15.0445C11.8386 14.4747 12.4161 13.882 12.9783 13.3122C13.1911 13.0994 13.4038 12.8791 13.6166 12.6664C15.2122 11.0708 15.2122 9.0041 13.6166 7.40851L11.5423 5.33424C11.3068 5.0987 11.0636 4.85556 10.8357 4.61243C10.3798 4.14135 9.90113 3.65507 9.40725 3.19919C8.67024 2.46978 7.78887 2.08228 6.86191 2.08228C5.93495 2.08228 5.03838 2.46978 4.27857 3.19919C4.27097 3.20679 4.27097 3.20679 4.26338 3.21438L1.68004 5.82051C0.707491 6.79306 0.152834 7.97836 0.0312648 9.35361C-0.151088 11.5722 0.502344 13.6389 1.00381 14.9914C2.2347 18.3117 4.07343 21.3889 6.81632 24.6865C10.1443 28.6602 14.1484 31.7982 18.7225 34.0093C20.47 34.8375 22.8026 35.8176 25.4087 35.9848C25.5683 35.9924 25.7355 36 25.8874 36C27.6426 36 29.1166 35.3693 30.2715 34.1156C30.2791 34.1004 30.2943 34.0928 30.3019 34.0776C30.697 33.599 31.1529 33.1659 31.6315 32.7024C31.9583 32.3909 32.2926 32.0642 32.6193 31.7223C33.3715 30.9397 33.7666 30.0279 33.7666 29.0933C33.7666 28.1512 33.3639 27.247 32.5965 26.4872L28.4252 22.3007ZM31.1453 30.3014C31.1377 30.3014 31.1377 30.309 31.1453 30.3014C30.8489 30.6205 30.545 30.9093 30.2183 31.2284C29.7244 31.6995 29.223 32.1933 28.7519 32.748C27.9845 33.5686 27.0803 33.9561 25.895 33.9561C25.781 33.9561 25.6595 33.9561 25.5455 33.9485C23.2889 33.8041 21.1918 32.9227 19.619 32.1705C15.3185 30.0887 11.5423 27.133 8.40431 23.3872C5.81338 20.2644 4.08102 17.3771 2.93372 14.2771C2.2271 12.3852 1.96877 10.9112 2.08274 9.52076C2.15872 8.63179 2.50063 7.89478 3.13127 7.26414L5.7222 4.67321C6.09451 4.3237 6.4896 4.13375 6.8771 4.13375C7.35578 4.13375 7.74328 4.42247 7.98642 4.66561C7.99402 4.67321 8.00162 4.68081 8.00921 4.68841C8.47269 5.12149 8.91338 5.56978 9.37686 6.04846C9.6124 6.29159 9.85554 6.53473 10.0987 6.78547L12.1729 8.85973C12.9783 9.66513 12.9783 10.4097 12.1729 11.2151C11.9526 11.4355 11.7399 11.6558 11.5195 11.8686C10.8813 12.522 10.2734 13.1298 9.6124 13.7225C9.59721 13.7377 9.58201 13.7453 9.57441 13.7605C8.92098 14.4139 9.04255 15.0521 9.17931 15.4852C9.18691 15.508 9.19451 15.5308 9.20211 15.5536C9.74157 16.8605 10.5014 18.0914 11.6563 19.5578L11.6639 19.5654C13.7609 22.1487 15.972 24.1622 18.4109 25.7046C18.7225 25.9021 19.0416 26.0617 19.3455 26.2137C19.619 26.3504 19.8774 26.4796 20.0977 26.6164C20.1281 26.6316 20.1585 26.6544 20.1889 26.6696C20.4472 26.7987 20.6904 26.8595 20.9411 26.8595C21.5717 26.8595 21.9668 26.4644 22.096 26.3352L24.6945 23.7367C24.9529 23.4784 25.3631 23.1669 25.8418 23.1669C26.3129 23.1669 26.7004 23.4632 26.9359 23.7215C26.9435 23.7291 26.9435 23.7291 26.9511 23.7367L31.1377 27.9232C31.9203 28.6982 31.9203 29.496 31.1453 30.3014Z"
                                  fill="#118DFF"
                                />
                                <path
                                  d="M19.4283 8.56338C21.419 8.89769 23.2273 9.83985 24.6709 11.2835C26.1146 12.7271 27.0491 14.5354 27.391 16.5261C27.4746 17.0276 27.9077 17.3771 28.4016 17.3771C28.4624 17.3771 28.5156 17.3695 28.5763 17.3619C29.1386 17.2707 29.5109 16.7389 29.4197 16.1766C29.0094 13.768 27.8697 11.5722 26.1298 9.83225C24.3898 8.0923 22.194 6.95259 19.7854 6.5423C19.2231 6.45112 18.6989 6.82342 18.6001 7.37808C18.5013 7.93274 18.866 8.4722 19.4283 8.56338Z"
                                  fill="#118DFF"
                                />
                                <path
                                  d="M35.9311 15.8804C35.2549 11.9142 33.3858 8.30511 30.5137 5.43304C27.6417 2.56098 24.0326 0.691864 20.0664 0.0156379C19.5118 -0.0831367 18.9875 0.296766 18.8887 0.851423C18.7975 1.41368 19.1699 1.93794 19.7321 2.03672C23.2728 2.63696 26.502 4.31613 29.0701 6.87667C31.6382 9.44481 33.3098 12.674 33.9101 16.2147C33.9936 16.7161 34.4267 17.0657 34.9206 17.0657C34.9814 17.0657 35.0346 17.0581 35.0954 17.0505C35.65 16.9669 36.0299 16.435 35.9311 15.8804Z"
                                  fill="#118DFF"
                                />
                              </svg>
                            </div>
                          </Swing>
                          <Tada delay={20} cascade>
                            <div className="contact-right position-relative">
                              <Zoom delay={50} right cascade>
                                <p className="mb-0 font-size-10">
                                  Call Us for Phone-Exclusive Deal
                                </p>
                              </Zoom>
                              <Zoom duration={2500} right cascade>
                                <a
                                  href="tel:1-773-4658-500"
                                  className="font-weight-bold mb-0 cursor-pointer"
                                >
                                  773-465-8500
                                </a>
                              </Zoom>
                            </div>
                          </Tada>
                        </div>
                      </div>
                    </div>
                    <div className="header-badge">
                      <img
                        src={BadgeHeaderImage}
                        alt="icon media"
                        className="img-fluid"
                      />
                    </div>
                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </Container>
            </Navbar>
          ))}
        </div>
      </header>
    </>
  );
};

export default Header;
